import React from "react";
import vg from "../assets/2.webp";
import {
  AiFillGoogleCircle,
  AiFillAmazonCircle,
  AiFillYoutube,
  AiFillInstagram,
} from "react-icons/ai";

function Home() {
  return (
    <>
      <div className="Home"id="home">
        <main className="main">
          <h1 className="h1">The Boys</h1>
          <p className="p">SuperHeroes</p>
        </main>
      </div>

      <div className="home2">
        <img className="img" src={vg} alt="Graphics" />
        <div className="div2">
          <p className="p2">
            Superheroes are the embodiment of our wildest dreams and
            aspirations. They represent the best version of ourselves, standing
            up for what is right and fighting against injustice. From the iconic
            Superman to the brooding Batman, these caped crusaders have captured
            our imagination for decades and continue to inspire us to be better.
          </p>
        </div>
      </div>

      <div className="home3" id="About">
        <div className="subhome3">
          <h1 className="ah1">Why we Are?</h1>
          <p className="p3">
            In a world filled with uncertainties and challenges, superheroes
            offer us a glimmer of hope and a reminder that there is always
            someone fighting for what is right. They are a symbol of resilience,
            courage, and perseverance in the face of adversity. Additionally,
            superheroes often serve as role models for children and adults
            alike, teaching us valuable lessons about responsibility, teamwork,
            and sacrifice.
          </p>
        </div>
      </div>

      <div className="home4" id="Brands">
        <div className="div4">
          <h1 className="ah2">Join Us</h1>

          <article className="parent">
            <div className="child">
              <AiFillGoogleCircle />
              <p className="p4">Google</p>
            </div>

            <div className="child">
              <AiFillAmazonCircle />
              <p className="p4">Amazon</p>
            </div>

            <div className="child">
              <AiFillInstagram />
              <p className="p4">Insta</p>
            </div>

            <div className="child">
              <AiFillYoutube />
              <p className="p4">Youtube</p>
            </div>
          </article>
        </div>
      </div>
    </>
  );
}

export default Home;
